export default __webpack_public_path__ + "static/media/Charge.645a3eed.svg";